import {Result} from "antd";
import {useEffect} from "react";
import {Navigate, useParams, useSearchParams} from "react-router-dom";
import {handleServiceBookingLink} from "../../../utils/meeting";
import {handleProductLink} from "../../../utils/products";
import {handleLiveClassLink} from "../../../utils/live-class";
import {REBRAND_BASE_URL} from "../../../services/config";

export function NavigateToPublicProfileRebrand() {
  const {username} = useParams();

  useEffect(() => {
    window.location.replace(`${REBRAND_BASE_URL}/${username}`);
  }, [username]);

  return null;
}

export function NavigateToNewLiveClass() {
  const [searchParams] = useSearchParams();
  const username = searchParams.get("username");
  const slug = searchParams.get("slug");
  const eventId = searchParams.get("eventId");

  if (!username || !slug || !eventId) {
    return (
      <Result
        status="error"
        title="An Error Occurred"
        subTitle={"You are missing some parameters!"}
      />
    );
  }

  return (
    <Navigate
      to={`/${username}/live-classes/details?slug=${slug}&eventId=${eventId}`}
      replace={true}
    />
  );
}
export function NavigateToLiveClassRebrand() {
  const [searchParams] = useSearchParams();
  const {username} = useParams();
  const slug = searchParams.get("slug");
  const eventId = searchParams.get("eventId");

  useEffect(() => {
    window.location.replace(
      handleLiveClassLink({
        eventId: eventId ?? "",
        slug: slug ?? "",
        username: username ?? "",
        windowNav: true,
      })
    );
  }, [eventId, slug, username]);

  return null;
}
export function NavigateToNewServices() {
  const [searchParams] = useSearchParams();
  const username = searchParams.get("username");
  const slug = searchParams.get("slug");
  const serviceId = searchParams.get("serviceId");

  if (!username || !slug || !serviceId) {
    return (
      <Result
        status="error"
        title="An Error Occurred"
        subTitle={"You are missing some parameters!"}
      />
    );
  }

  return (
    <Navigate
      to={`/${username}/services/details?slug=${slug}&serviceId=${serviceId}`}
      replace={true}
    />
  );
}
export function NavigateToServicesRebrand() {
  const [searchParams] = useSearchParams();
  const {username} = useParams();
  const slug = searchParams.get("slug");
  const serviceId = searchParams.get("serviceId");

  useEffect(() => {
    window.location.replace(
      handleServiceBookingLink({
        serviceId: serviceId ?? "",
        slug: slug ?? "",
        username: username ?? "",
        windowNav: true,
      })
    );
  }, [serviceId, slug, username]);

  return null;
  // <Button
  //   href={handleServiceBookingLink({
  //     serviceId: serviceId,
  //     slug: slug,
  //     username: username,
  //     windowNav: true,
  //   })}
  //   type="primary"
  //   size="small"
  // >
  //   Continue to v2
  // </Button>
}
export function NavigateToNewProducts() {
  const [searchParams] = useSearchParams();
  const username = searchParams.get("username");
  const slug = searchParams.get("slug");
  const productId = searchParams.get("productId");

  if (!username || !slug || !productId) {
    return (
      <Result
        status="error"
        title="An Error Occurred"
        subTitle={"You are missing some parameters!"}
      />
    );
  }

  return (
    <Navigate
      to={`/${username}/products/details?slug=${slug}&productId=${productId}`}
      replace={true}
    />
  );
}
export function NavigateToProductsRebrand() {
  const [searchParams] = useSearchParams();
  const {username} = useParams();
  const slug = searchParams.get("slug");
  const productId = searchParams.get("productId");

  useEffect(() => {
    window.location.replace(
      handleProductLink({
        productId: productId ?? "",
        slug: slug ?? "",
        username: username ?? "",
        windowNav: true,
      })
    );
  }, [productId, slug, username]);

  return null;
}

export function NavigateToNewServices2() {
  const [searchParams] = useSearchParams();
  const currentUrlStep = searchParams.get("currentStep");
  const {username, slug, id} = useParams();

  if (!username || !slug || !id) {
    return (
      <Result
        status="error"
        title="An Error Occurred"
        subTitle={"You are missing some parameters!"}
      />
    );
  }

  return (
    <Navigate
      to={`/${username}/services/details?slug=${slug}&serviceId=${id}`}
      replace={true}
    />
  );
}
